import { render } from "./ProductBoxCount.vue?vue&type=template&id=1547235c"
import script from "./ProductBoxCount.vue?vue&type=script&lang=js"
export * from "./ProductBoxCount.vue?vue&type=script&lang=js"

import "./ProductBoxCount.vue?vue&type=style&index=0&id=1547235c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__